import styled from 'styled-components'
import { Button } from '@components/Button'



export const TripSettingsButton = styled(Button).attrs({ variant: 'secondary' as const })``

